import type { CreatorProfile } from '@/types/database'

/** Hyperlocal, Hybrid, Broad (clients.creator_profile): set in onboarding,
 *  changed in Settings › Voice. It shapes the topics suggested; the preset is
 *  onboarding's starting mix. */
export const PROFILES: { id: CreatorProfile; label: string; line: string; preset: string[] }[] = [
  {
    id: 'hyperlocal', label: 'Hyperlocal', line: 'Your town is the story. Council, permits, openings, what is happening down the street.',
    preset: ['civic-government', 'new-business-openings', 'development-construction', 'events', 'food-drink'],
  },
  {
    id: 'hybrid', label: 'Hybrid', line: 'Local first, with the national stories your audience talks about.',
    preset: ['civic-government', 'events', 'food-drink', 'real-estate-market', 'technology'],
  },
  {
    id: 'broad', label: 'Broad', line: 'National and beyond, with your area as one voice among many.',
    preset: ['technology', 'finance', 'pro-sports', 'events', 'celebrity-news'],
  },
]
